import {
    ChangeDetectorRef,
    Component,
    ContentChildren,
    DoCheck,
    ElementRef,
    EventEmitter,
    HostBinding,
    Input,
    OnInit,
    Output,
    QueryList,
    Renderer2,
    ViewChild,
} from "@angular/core";
import { SpsIcon, StdButtonKind } from "@spscommerce/ds-shared";
import { AttributePresenceInput } from "@spscommerce/ng-utils";
import * as nanoidImport from "nanoid";

import { SpsDropdownOptionComponent } from "../dropdown-option/sps-dropdown-option.component";
import { SpsDropdownComponent } from "../dropdown/sps-dropdown.component";

// Some imports need this to work in all contexts incl ng-packagr/rollup
const nanoid = (<any>nanoidImport).default || nanoidImport;

@Component({
    selector: "sps-split-button",
    templateUrl: "./sps-split-button.component.html"
})
export class SpsSplitButtonComponent implements OnInit, DoCheck {
    static readonly displayName = "sps-split-button";
    static readonly props = {
        label: "string",
        kind: "StdButtonKind",
        href: "string",
        icon: "SpsIcon",
        disabled: "boolean",
        clicked: { event: true, type: "void" },
    };

    @Input() label: string;
    @Input() id: string;
    @Input() kind = StdButtonKind.DEFAULT;
    @Input() href: string;
    @Input() icon: SpsIcon;

    @HostBinding("class.disabled")
    @Input()
    @AttributePresenceInput()
    disabled: boolean;

    private _isOpen = false;
    @HostBinding("class.sps-split-button--open")
    get isOpen() {
        return this._isOpen;
    }

    @Output() clicked = new EventEmitter<void>();

    @HostBinding("class.sps-split-button") readonly _spsSplitButtonClass = true;

    @ContentChildren(SpsDropdownOptionComponent) options: QueryList<SpsDropdownOptionComponent>;
    @ViewChild("dropdown", { static: false }) dropdown: SpsDropdownComponent;

    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private elementRef: ElementRef,
        private renderer: Renderer2,
    ) {}

    ngOnInit() {
        this.id = this.id || nanoid();
        this.renderer.addClass(this.elementRef.nativeElement, `sps-split-button--${this.kind}`);
    }

    onClick() {
        this.clicked.emit();
    }

    ngDoCheck() {
        this._isOpen = this.dropdown && this.dropdown.isOpen;
        this.changeDetectorRef.markForCheck();
    }
}
